import { isCSSVar } from './basler-components.es782.js';

function setStyle(element, name, value) {
    isCSSVar(name)
        ? element.style.setProperty(name, value)
        : (element.style[name] = value);
}

export { setStyle };
